<template>
    <div class="payFail">
        <div class="pay-item">
            <div class="pay-fail">微信支付失败</div>
            <div class="pay-back">
              <van-button plain hairline type="primary" @click="goPay">返 回</van-button>
            </div>
        </div>
    </div>
</template>
<script>
  import { Button,SubmitBar } from 'vant';
  
  export default {
    components: {
      [Button.name]: Button
		},
    data(){
      return{

      }
    },
    created() {
     
    },
    methods: {
      goPay(){//返回
        this.$router.push({ name: 'Pay',	query: {	}});
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .payFail{
    
    .pay-back{
      position:absolute;
      top: 4rem;
      left: 2.2rem;
    }
    .pay-fail{
      font-size: .28rem;
      text-align: center;
      margin-top: 2.6rem;
    }
    .van-button__text{
      font-size: .26rem;
    }
    .van-button--normal{
      padding: 0 1.2rem;
    }
  }
    
</style>